export const ROOT_DRIVE_NAME = "My Folders";
export const SHAREPOINT_FOLDER_NAME = "Sharepoint Folder";
